module.exports = __webpack_public_path__ + "static/media/doodle.0bb81744.svg";